import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dragula"
export default class extends Controller {

  static values = {
    onDrop: String,
  }

  connect() {
    // Require global dragula (set on window by adminkit)
    const dragula = window.dragula
    if (!dragula) return

    const container = this.element

    this.drake = dragula([container], {
      direction: "vertical",
      moves: (el, _container, handle) => {
        let cur = handle;
        while (cur && cur !== el) {
          if (cur.classList && cur.classList.contains("dragula-move")) {
            return true;
          }
          cur = cur.parentElement;
        }
        return false;
      },
      mirrorContainer: container,
    })

    this.drake.on("drop", (el) => {
      const expr = this.onDropValue
      if (expr) {
        try {
          const fn = eval(expr) // e.g. "$.sortDynamicStatuable"
          if (typeof fn === "function") fn(el)
        } catch (e) {
          console.error("dragula onDrop eval error:", e)
        }
      }
    })
  }

  disconnect() {
    if (this.drake) {
      this.drake.destroy()
      this.drake = null
    }
  }
}


